<template lang="pug">
  .tooltip(v-if="item" :class="`rarity-${item.fields.rarity}`")
    .tooltip__header(v-html="item.title")
    .tooltip__wrap
      .tooltip__item
        .tooltip__item__image
          img(:src="getImageUrl" @error="noImage = true")
        .tooltip__item__info
          .tooltip__item__type(v-if="item.fields.rarity") {{ $t(`tooltip.rarity.${item.fields.rarity}`) }}
          .tooltip__item__notice(v-html="item.fields.item_notice")
      .tooltip__info
        .tooltip__info__level(v-if="item.fields.level") {{ $t("tooltip.level_label") }}
          span {{ item.fields.level }}
        .tooltip__info__condition {{ item.fields.condition }}
        .tooltip__info__description(v-html="item.description")
        .tooltip__info__warning(v-html="item.fields.warning")
</template>

<script>
import "./item-tooltip.styl";
import { mapState } from "vuex";
export default {
  name: "ItemTooltip",
  /**
   * you should provide at least one of this props,
   */
  props: {
    itemContent: {
      type: Object,
      required: false,
      default: null,
    },
    itemName: {
      type: String,
      required: false,
      default: "",
    },
  },

  data() {
    return {
      noImage: false,
    };
  },
  computed: {
    item() {
      return this.itemContent || this.items[this.itemName];
    },
    getImageUrl() {
      if (this.noImage || !this.item.images.tooltip) {
        return this.default_image;
      } else {
        return this.item.images.tooltip;
      }
    },
    ...mapState("tooltip", ["items", "default_image"]),
  },
  created() {
    if (!this.itemName && !this.itemContent) {
      throw new Error("you should provide one of this props (itemName/itemContent");
    }
    if (this.itemContent) {
      this.$store.commit("tooltip/setItem", this.itemContent);
    }
    if (this.itemName) {
      this.$store.dispatch("tooltip/loadItem", this.itemName);
    }
  },
};
</script>
